import React, { Component } from 'react';
import { Card, CardHeader, CardBody, CardFooter, Label, FormGroup } from 'reactstrap';
import { Row, Col, PageHeader, Input, Table, Spin, Select, DatePicker, Button, Tag, Icon, Modal, Divider } from 'antd';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { urlapi, token, pathimages, CheckTokenExp } from '../../config';
import moment from 'moment';

class TemplateName extends Component {
    constructor(props) {
        super(props);

        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.RequestTemplate = this.RequestTemplate.bind(this);

        this.state = {
            tempName: undefined,
            dropdownlist: [],
            data: []
        }
    }

    componentDidMount() {
        this.RequestTemplate()
    }

    RequestTemplate() {
        if (!CheckTokenExp()) {
            fetch(urlapi + "api/Template", {
                method: 'get',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({
                                    dropdownlist: json
                                });
                            }.bind(this)
                        );
                    }
                }.bind(this)
            ).catch(function () {
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }
    }

    handleSearch(value) {
        if (value) {
            let arr = this.state.dropdownlist.filter(item => item.ltmP_NAME.toLowerCase().indexOf(value.toLowerCase()) > -1);
            this.setState({ data: arr })
        } else {
            this.setState({ data: [] });
        }
    };

    handleChange(value) {
        this.setState({ tempName: value });
        this.props.onchange(value)
    };

    render() {
        const { Option } = Select;
        const optionsTempname = this.state.data.map(d => <Option key={d.ltmP_NAME}>{d.ltmP_NAME}</Option>);

        return (
            <Select
                showSearch
                allowClear
                value={this.state.tempName}
                placeholder="Template Name"
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                onSearch={this.handleSearch}
                onChange={this.handleChange}
                notFoundContent={null}
            >
                {optionsTempname}
            </Select>

        );
    }
}

export default TemplateName;



// WEBPACK FOOTER //
// ./src/views/Dropdown/TemplateName.js